import { Euler, Quaternion, Vector3 } from 'three';
import { Tween, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
export default class ZoomModule extends ViewerModule {
    constructor(instruments, level) {
        super();
        this.__inited = false;
        this.level = level;
        this.instruments = instruments;
        this.dish1Cap = instruments.dish1.getObjectByName('cap');
        this.dish1 = instruments.dish1;
    }
    init() {
        this.dish1Cap = this.instruments.dish1.getObjectByName('cap');
        this.dish1 = this.instruments.dish1;
        this.dish1Cap.visible = false;
        this.dish1.userData.pcPosition = new Vector3(1.52, 6.86, 6.42);
        this.dish1.userData.pcRotation = new Quaternion().setFromEuler(new Euler(1.15, 0, 0.34));
        this.dish1.userData.pcScale = 1;
        this.dish1.userData.zsPosition = new Vector3(5, 6.86, 3.42);
        this.dish1.userData.zsRotation = new Quaternion().setFromEuler(new Euler(0.2, 1.54, 1.34));
        this.dish1.userData.zsScale = 4;
        const zoomDishPosition = this.dish1.userData[Viewer.controls.zController ? 'zsPosition' : 'pcPosition'];
        this.zoomAnimation(this.dish1, zoomDishPosition, () => {
            this.fire('level_ended');
            if (this.level.loopBurned)
                this.fire('zoomed_green');
            else
                this.fire('zoomed_red');
        });
    }
    zoomAnimation(dish, newPosition, onComplete) {
        const oldPos = dish.position.clone();
        const oldRotation = new Quaternion().setFromEuler(dish.rotation.clone());
        const newPos = newPosition;
        const newRotation = new Quaternion();
        const countRotation = () => {
            const a = dish.rotation.clone();
            a.x = 1.15;
            a.z = 0.34;
            if (Viewer.controls.zController)
                a.set(0.2, 1.54, 1.34);
            newRotation.setFromEuler(a);
        };
        countRotation();
        const newScale = Viewer.controls.zController ? 3 : 0;
        new Tween({ alpha: 0 }).to({ alpha: 1 }, 1000)
            .onUpdate((alpha) => {
            const currentPos = oldPos.clone().lerp(newPos, alpha);
            Quaternion.slerp(oldRotation, newRotation, dish.quaternion, alpha);
            dish.position.copy(currentPos);
            dish.scale.setScalar(1 + newScale * alpha);
        })
            .onComplete(onComplete)
            .start();
    }
    update() {
    }
}
